export enum Region {
  Ecuador = 'Ecuador',
  Peru = 'Peru',
  Colombia = 'Colombia',
}
